module.exports = __webpack_public_path__ + "static/media/PaymentMode.2c3c2c06.svg";